export const EarlyStageCavitySvg = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.73994 19.443C-0.166045 11.2458 1.78377 1 1.78377 1C6.47988 3.04922 20.4009 9.19703 20.4014 11.2461C20.4018 13.2951 6.45416 22.3072 4.73994 19.443Z"
        fill="#E6CC41"
      />
    </svg>
  );
};
